import { emptySplitApi } from './index'

export const customDatabaseApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
        getRequiredOptionalFields: builder.mutation({
            query: (model) => ({
                url: `api/v1/foundation-service/custom-database/required-optional-fields`,
                method: "GET"
            }),
        }),
        confirmImportCustomDatabase: builder.mutation({
            query: (model) => ({
                url: `api/v1/foundation-service/custom-database/confirm-import`,
                method: "POST",
                body: model
            }),
        }),
        getCustomDatabaseList: builder.mutation({
            query: (model) => ({
                url: `api/v1/foundation-service/custom-database/list?`
                    + `pageNumber=${model?.pageNumber || 0}`
                    + `&pageSize=${model?.pageSize || ''}`
                    + `&orderField=${model?.orderField || 'importedDate'}`
                    + `&orderDirection=${model?.orderDirection || 'asc'}`,
                method: "GET"
            }),
        }),
        deleteCustomDatabase: builder.mutation({
            query: (customDatabaseId) => ({
                url: `api/v1/foundation-service/custom-database/delete/${customDatabaseId}`,
                method: "DELETE"
            }),
        }),
        getFileList: builder.mutation({
            query: () => ({
                url: `api/v1/foundation-service/custom-database/file-list`,
                method: "GET"
            }),
        }),
        getFileList2: builder.query({
            query: () => ({
                url: `api/v1/foundation-service/custom-database/file-list`,
                method: "GET"
            }),
        }),
        getMappedFields: builder.mutation({
            query: (customItemId) => ({
                url: `api/v1/foundation-service/custom-database/mapped-fields/${customItemId}`,
                method: "GET"
            }),
        }),
        getCustomDatabaseProvinceOrStateList: builder.mutation({
            query: (customDatabaseId) => ({
                url: `api/v1/foundation-service/custom-database/province-or-state/${customDatabaseId}`,
                method: "GET"
            }),
        }),
        getCustomDatabaseCityList: builder.mutation({
            query: (model) => ({
                url: `api/v1/foundation-service/custom-database/city/${model.customDatabaseId}`,
                method: "POST",
                body: [...model.provinceOrStateList]
            }),
        }),
        getCustomDatabaseProvinceOrState: builder.query({
            query: (customDatabaseId) => ({
                url: `api/v1/foundation-service/custom-database/province-or-state/${customDatabaseId}`,
                method: "GET"
            }),
            transformResponse: (response) => response.map(item => ({
                id: item.id,
                label: item.provinceOrState,
                value: item.provinceOrState,
            }))
        }),
        getCustomDatabaseCity: builder.query({
            query: (model) => ({
                url: `api/v1/foundation-service/custom-database/city/${model.customDatabaseId}`,
                method: "POST",
                body: [...model.provinceOrStateList]
            }),
            transformResponse: (response) => response.map(item => ({ 
                id: item.id,
                label: item.city,
                value: item.city,
                secondaryAction: item.provinceOrState,
            }))
        }),
    }),
  overrideExisting: false,
});

export const { 
    useGetRequiredOptionalFieldsMutation,
    useConfirmImportCustomDatabaseMutation,
    useGetCustomDatabaseListMutation,
    useDeleteCustomDatabaseMutation,
    useGetFileListMutation,
    useGetFileList2Query,
    useGetMappedFieldsMutation,
    useGetCustomDatabaseProvinceOrStateListMutation,
    useGetCustomDatabaseCityListMutation,
    useGetCustomDatabaseProvinceOrStateQuery,
    useGetCustomDatabaseCityQuery,
} = customDatabaseApi;
